module.exports = __webpack_public_path__ + "img/TitreSimple.7411c86e.png";